import {
  defineStore
} from "pinia";
import {
  useUserStore
} from "@/stores/user";

// import  axios from "axios";
const env =
  import.meta.env;
// 这里制作和数据库交互的接口，不做数据包装
const api_host = env.VITE_APP_API_HOST;

export const useCommonStore = defineStore("common", {
  state: () => ({
    speed: 0,
    index: null,
    innermsg: false,
    checkdata: {},
    is_fully_checked: false,
    ischecke: 1,


  }),
  getters: {
    funNotScreen(state) {
      return state.index >= 3
    },
    isV0(state) {
      return state.index == 3
    }
  },
  actions: {
    setSpeed: (data) => {
      state.speed = data
    },
    getUser: async (mobile, code) => {
      let res = await fetch(`${api_host}api/user/login`, {
        method: "post",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          code: code,
          mobile: mobile
        })
      });
      res = await res.json();
      return res;
    },
    getHospitalList: async () => {
      let res = await fetch(`${api_host}api/field/hospitalList`, {
        method: "get",
        headers: {
          "Content-Type": "application/json"
        },
      });
      res = await res.json();
      console.log(res, "医院列表");
      return res;
    },
    getVerificationCode: async (mobile) => {
      let res = await fetch(`${api_host}api/user/sendCode`, {
        method: "post",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          mobile: mobile
        })
      });
      res = await res.json();
      console.log(res, "验证码");
      return res;
    },
    registered: async (name, mobile, hospital) => {
      let res = await fetch(`${api_host}api/user/register`, {
        method: "post",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: name,
          mobile: mobile,
          hospital: hospital
        })
      });
      res = await res.json();
      console.log(res, "注册");
      return res;
    },
    // 登录app接口
    getUserapp: async (name, mobile) => {
      let res = await fetch(`${api_host}api/user/mobile/login`, {
        method: "post",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: name,
          mobile: mobile
        })
      });
      res = await res.json();
      console.log(res, "登录返回信息");
      return res;
    },
    createData: async (patient) => {
      const userStore = useUserStore();
      let res = await fetch(`${api_host}api/field`, {
        method: "put",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          user_id: userStore.id,
          // hospital: userStore.hospital,
          fields: patient
        })
      });
      res = await res.json();
      return res;
    },
    //更新ctp计算
    computectp: async () => {
      {
        fetch(`${api_host}api/field/computectp`, {
          method: "get",

        });
      }
    },
    updateData: async (data) => {
      let res = await fetch(`${api_host}api/field`, {
        method: "post",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          user_id: data.user_id,
          id: data.id,
          fields: data.fields,
          isExclude: data.isExclude // 添加 isExclude 字段
        })
      });
      //再单独提交一下数据
      {
        fetch(`${api_host}api/field/updateCtp`, {
          method: "post",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            user_id: data.user_id,
            id: data.id,
            fields: data.fields,
          })
        });
      }
      res = await res.json();
      return res;
    },
    getData: async (id) => {
      const userStore = useUserStore();
      let res = await fetch(`${api_host}api/field/info?user_id=${userStore.id}&id=${id}`, {
        method: "get",
        headers: {
          "Content-Type": "application/json"
        }
      });
      res = await res.json();
      if (res.result === "success") {
        res.data.fields = JSON.parse(res.data.fields);
      }
      return res;
    },
    getDataList: async () => {
      const userStore = useUserStore();
      let res = await fetch(`${api_host}api/field/list?user_id=${userStore.id}`, {
        method: "get",
        headers: {
          "Content-Type": "application/json"
        }
      });
      console.log(res, "id请求")
      // return
      res = await res.json();
      if (res.result === "success") {
        res.data = res.data.map((item) => {
          item.fields = JSON.parse(item.fields);
          return item;
        });
      }
      return res;
    },
    // 通过医院获取数据
    gethospitals: async (str) => {
      // let res = await axios.get(`${api_host}api/field/list`, {
      //   params: {
      //     hospital: str
      //   }
      // })
      let res = await fetch(`${api_host}api/field/list?hospital=${encodeURIComponent(str)}`, {
        method: "get",
        headers: {
          "Content-Type": "application/json"
        }
      });
      console.log(res, "hostalres")
      res = await res.json();
      if (res.result === "success") {
        res.data = res.data.map((item) => {
          item.fields = JSON.parse(item.fields);
          return item;
        });
      }
      return res;
    },
    getIDcard: async (id, idcard, name) => {
      let res = await fetch(`${api_host}api/field/IDExists?id=${id}&id_card=${idcard}&patient_name=${name}`, {
        method: "get",
        headers: {
          "Content-Type": "application/json"
        }
      });
      return await res.json()
    },
    // 获取患者列表
    getpatients: async (id, name) => {
      let res = await fetch(`${api_host}api/field-mobile/list?user_id=${id}&patient_name=${name||''}`, {
        method: "get",
        headers: {
          "Content-Type": "application/json"
        },
      });
      return await res.json();
    },
    // 获取患者访视列表
    getperiods: async (id) => {
      let res = await fetch(`${api_host}api/field-mobile/periods?field_id=${id}`, {
        method: "get",
        headers: {
          "Content-Type": "application/json"
        },
      });
      return await res.json();
    },
    // 获取报告
    getreports: async (data) => {
      let res = await fetch(`${api_host}api/field-mobile/reports`, {
        method: "post",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json"
        },
      });
      return await res.json();
    },
    // 更新图片
    upreports: async (data) => {
      let res = await fetch(`${api_host}api/field-mobile/update-report`, {
        method: "post",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json"
        },
      });
      return await res.json();
    },
    // 获取患者访视期核查信息
    getcheck: async (data) => {
      let res = await fetch(`${api_host}api/field-check-record/get-list-by-period?${data}`, {
        method: "get",
        headers: {
          "Content-Type": "application/json"
        },
      });
      return await res.json();
    },
    //处理核查
    setcheck: async (data) => {
      let res = await fetch(`${api_host}api/field-check-record/process-record`, {
        method: "post",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json"
        },
      });
      return await res.json();
    },
    //一键核查
    allcheck: async (data) => {
      let res = await fetch(`${api_host}api/field-check-record/quick-check-by-period`, {
        method: "post",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json"
        },
      });
      return await res.json();
    },
    //是否全部核查
    getcheckall: async (data) => {
      let res = await fetch(`${api_host}api/field-check-record/is-fully-checked?${data}`, {
        method: "get",
        headers: {
          "Content-Type": "application/json"
        },
      });
      return await res.json();
    },



    //新增质疑
    addquestion: async (data) => {
      let res = await fetch(`${api_host}api/field-review-inquiry-log/add`, {
        method: "post",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json"
        },
      });
      return await res.json();
    },
    //获取质疑列表
    getquestionlist: async (data) => {
      let res = await fetch(`${api_host}api/field-review-inquiry-log/list?${data}`, {
        method: "get",
        headers: {
          "Content-Type": "application/json"
        },
      });
      return await res.json();
    },
    //撤销质疑
    revokequestion: async (data) => {
      let res = await fetch(`${api_host}api/field-review-inquiry-log/cancel`, {
        method: "post",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json"
        },
      });
      return await res.json();
    },
    //处理质疑
    processquestion: async (data) => {
      let res = await fetch(`${api_host}api/field-review-inquiry-log/handle`, {
        method: "post",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json"
        },
      });
      return await res.json();
    },
    //关闭质疑
    closequestion: async (data) => {
      let res = await fetch(`${api_host}api/field-review-inquiry-log/close`, {
        method: "post",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json"
        },
      });
      return await res.json();
    },
    //站内信
    getinnermsg: async (user_id) => {
      let res = await fetch(`${api_host}api/field-review-inquiry-operation-log/notifications?user_id=${user_id}`, {
        method: "get",
        headers: {
          "Content-Type": "application/json"
        },
      });
      return await res.json();
    },
    // upload: async (data)=>{
    //   let res = await fetch(`${api_host}api/file/upload`, {
    //     method: "post",
    //     // 文件上传不需要设置headers，会自动设置
    //     // headers: {
    //       // 之前报错是因为只是注释掉了下面这一行
    //     //   "Content-Type": "multipart/form-data",
    //     // },
    //     body:data
    //   },(progressEvent)=> { // 处理上传进度事件
    //     let percent = (progressEvent.loaded / progressEvent.total * 100).toFixed(0);   //计算出上传的进度，去整数位
    //     param.percentage = percent;  //动态设置param的percentage
    //     console.log(percent)
    // }
    // );
    //   return await res.json();
    // },
    // upload1: async (data)=>{
    //   let uploadPercent = null
    //   const res = await axios({
    //     method: 'post',
    //     url: `${api_host}api/file/upload`,
    //     data: data,
    //     onUploadProgress: (progressEvent_1) => {
    //       // 计算上传进度百分比
    //       uploadPercent = Math.round((progressEvent_1.loaded * 100) / progressEvent_1.total);
    //       common.state.speed = uploadPercent
    //       console.log(uploadPercent, '进度');
    //     }
    //   });
    //   // console.log(res,uploadPercent,"444");
    //   return res.data;


    // },
    // 判断图片是否存在
    upload_not: async (name) => {
      let res = await fetch(`${api_host}api/file/isExist?name=${name}`, {
        method: "get",
        headers: {
          "Content-Type": "application/json"
        },
      });
      return await res.json();
    },
    // 删除已上传图片
    pic_del: async (name, id, path, index) => {
      let res = await fetch(`${api_host}api/file/del?name=${name}&id=${id}&path=${path}&index=${index}`, {
        method: "delete",
        headers: {
          "Content-Type": "application/json"
        },
      });
      return await res.json();
    },
  }
});